import {
    notifyExternalPricelistCreated,
    notifyExternalPricelistDeleted,
    notifyExternalPricelistUpdated
} from '../../../common/signalr/signalrActions';
import { createEpicFromAsyncAction, createEpicFromAsyncActionEmptyRequest } from '../../../utils';
import { pricePrgError } from '../../ui/redux/uiSlices';
import {
    closeCreateExternalPricelistDialog,
    createExternalPricelist,
    externalPricelistsSelected,
    fetchExternalPricelists,
    removeExternalPricelist,
    updateExternalPricelist
} from './externalPricelistSlices';

const fetchExternalPricelists$ = createEpicFromAsyncActionEmptyRequest(
    fetchExternalPricelists,
    ({ externalPricelistClient }) => externalPricelistClient.get()
);

const updateExternalPricelists$ = createEpicFromAsyncAction(
    updateExternalPricelist,
    (payload, { externalPricelistClient }) =>
        externalPricelistClient.update(payload.externalPricelistId, payload).then(() => payload),
    payload => notifyExternalPricelistUpdated(payload.externalPricelistId)
);

const createExternalPricelist$ = createEpicFromAsyncAction(
    createExternalPricelist,
    (payload, { externalPricelistClient }) => externalPricelistClient.create(payload),
    (_, resp) => [
        notifyExternalPricelistCreated(resp),
        externalPricelistsSelected(resp.externalPricelistId),
        closeCreateExternalPricelistDialog()
    ],
    (_, err) => pricePrgError(err)
);

const removeExternalPricelist$ = createEpicFromAsyncAction(
    removeExternalPricelist,
    (payload, { externalPricelistClient }) => externalPricelistClient.delete(payload).then(() => payload),
    req => notifyExternalPricelistDeleted(req)
);

export default [
    fetchExternalPricelists$,
    updateExternalPricelists$,
    createExternalPricelist$,
    removeExternalPricelist$
];
